import { render, staticRenderFns } from "./DebtorReport.vue?vue&type=template&id=2b1c7dc7&scoped=true&"
import script from "./DebtorReport.vue?vue&type=script&lang=js&"
export * from "./DebtorReport.vue?vue&type=script&lang=js&"
import style0 from "./DebtorReport.vue?vue&type=style&index=0&id=2b1c7dc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c7dc7",
  null
  
)

export default component.exports